export enum DATA_QA {
  ROOT = 'dnc-import-details-step',
  ROW_COUNT = 'dnc-import-details-step__row-count',
  BACK = 'dnc-import-details-step__back',
  IMPORT = 'dnc-import-details-step__import',
  NAME_INPUT = 'dnc-import-details-step__name-input',
}

export enum ValidationErrorType {
  REQUIRED = 'REQUIRED',
  TOO_LONG = 'TOO_LONG',
}
